"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverWidget = exports.PopoverAlertType = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var AlertStyles_1 = require("../AlertStyles");
Object.defineProperty(exports, "PopoverAlertType", { enumerable: true, get: function () { return AlertStyles_1.AlertType; } });
var PopoverBase_1 = require("./PopoverBase");
var PopoverStyles_1 = require("./PopoverStyles");
exports.PopoverWidget = React.forwardRef(function (props, ref) {
    var triggerElement = props.triggerElement, popoverProps = tslib_1.__rest(props, ["triggerElement"]);
    var _a = React.useState(false), isVisible = _a[0], setIsVisible = _a[1];
    var triggerElRef = React.useRef();
    var triggerId = React.useState(triggerElement.props.id || DomUtil_1.generateId())[0];
    var defaultPopoverId = React.useState(DomUtil_1.generateId())[0];
    var popoverId = props.id || defaultPopoverId;
    React.useImperativeHandle(ref, function () { return ({
        toggle: function (shown) {
            if (shown === void 0) { shown = !isVisible; }
            if (shown && !triggerElRef.current) {
                triggerElRef.current = document.getElementById(triggerId) || undefined;
            }
            setIsVisible(shown);
        }
    }); });
    var handleClose = function () { return setIsVisible(false); };
    var clonedTrigger = React.cloneElement(triggerElement, {
        'aria-controls': isVisible ? popoverId : undefined,
        'aria-haspopup': 'dialog',
        className: TypeStyle.classes(triggerElement.props.className, PopoverStyles_1.PopoverTriggerStyleName),
        'data-tb-test-id': Declarative_1.makeTestId(props.testId, 'PopoverWidget-Trigger'),
        onClick: function (e) {
            var _a, _b;
            triggerElRef.current = e.currentTarget;
            setIsVisible(!isVisible);
            (_b = (_a = triggerElement.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        }
    });
    return React.createElement(React.Fragment, null,
        clonedTrigger,
        isVisible && triggerElRef.current &&
            React.createElement(PopoverBase_1.PopoverBase, tslib_1.__assign({}, popoverProps, { id: popoverId, onClose: handleClose, trigger: triggerElRef.current })));
});
exports.PopoverWidget.displayName = 'PopoverWidget';
exports.PopoverWidget.defaultProps = {
    placement: 'auto',
    width: 300,
    zIndex: 1,
};
//# sourceMappingURL=PopoverWidget.js.map